import React, { useState, useEffect } from "react";
import "./styles/ButtonsSequence.css";
function waitTimer(delay) {
    return new Promise((resolve) => setTimeout(resolve, delay));
}

function ButtonsSequence({ CallFunction, data, selectedRemote }) {
    const [buttonGroups, setButtonGroups] = useState([]);
    const [savedSequence, setSavedSequence] = useState([]);
    const [message, setMessage] = useState("");
    const [AllSavedSequences, setAllSavedSequences] = useState([]);
    const [saveSequenceName, setSaveSequenceName] = useState("");

    const [ShowSequence, setShowSequence] = useState("");

    useEffect(() => {
        const savedData = localStorage.getItem("buttonSequenceData");
        if (savedData) {
            const parsedData = JSON.parse(savedData);
            setButtonGroups(parsedData.buttonGroups || []);
            setSavedSequence(parsedData.buttonGroups || []);
        }
    }, []);

    const getAllSaveSequences = () => {
        const data = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith("buttonSequenceData_")) {
                const value = localStorage.getItem(key);
                data.push({ key, value });
            }
        }
        setAllSavedSequences(data);
    };

    useEffect(() => {
        getAllSaveSequences();
    }, []);

    const selectSequence = (name) => {
        setSaveSequenceName(name.replace("buttonSequenceData_", ""));
        const savedData = localStorage.getItem(name);
        if (savedData) {
            const parsedData = JSON.parse(savedData);
            setButtonGroups(parsedData.buttonGroups || []);
            setSavedSequence(parsedData.buttonGroups || []);
        }
    };

    const handleDelayButtonClick = (groupIndex, delay) => {
        const updatedGroups = [...buttonGroups];
        const group = updatedGroups[groupIndex];

        if (delay && !isNaN(delay)) {
            group.delay = parseInt(delay, 10);
            setButtonGroups(updatedGroups);
            setMessage(`Delay added to sequence in group ${groupIndex + 1}`);
        } else {
            setMessage("Invalid delay input. Please enter a valid number.");
        }
    };

    const handleButtonSelectChange = (index, value) => {
        const updatedGroups = [...buttonGroups];
        updatedGroups[index].selectedButton = value;
        setButtonGroups(updatedGroups);
    };

    const addButtonGroup = () => {
        setButtonGroups([...buttonGroups, { selectedButton: "", delay: 10 }]);
    };

    const removeButtonGroup = () => {
        if (buttonGroups.length > 0) {
            setButtonGroups(buttonGroups.slice(0, -1));
        }
    };

    const clearSequence = () => {
        setSavedSequence([]);
        localStorage.removeItem(`buttonSequenceData_${saveSequenceName}`);
        setSaveSequenceName("");
        getAllSaveSequences();
        setMessage(`Sequence ${saveSequenceName} cleared.`);
    };

    const AddSequence = () => {
        if (
            !saveSequenceName ||
            saveSequenceName.length < 1 ||
            saveSequenceName === ""
        ) {
            setMessage(`Please provide valide sequence name.`);
            return;
        }
        localStorage.removeItem(`buttonSequenceData_${saveSequenceName}`);
        setSavedSequence(buttonGroups);
        localStorage.setItem(
            `buttonSequenceData_${saveSequenceName}`,
            JSON.stringify({ buttonGroups })
        );
        getAllSaveSequences();
        setMessage(`Sequence ${saveSequenceName} saved.`);
    };

    const executeSequence = async () => {
        console.log(savedSequence);
        const selectedRemoteKey = `${selectedRemote}_lirc`;
        const selectedRemoteData = data[selectedRemoteKey];

        let count = 1;
        for (const item of savedSequence) {
            const buttonValue = selectedRemoteData[item.selectedButton];
            setMessage(`Button number: ${count} - Send button: ${buttonValue}`);
            CallFunction(buttonValue);
            await waitTimer(item.delay);
            count++;
        }
    };

    const populateButtons = () => {
        const selectedRemoteKey = `${selectedRemote}_lirc`;
        const selectedRemoteData = data[selectedRemoteKey];

        if (!selectedRemoteData) {
            console.error(`Key ${selectedRemoteKey} not found in data`);
            return [];
        }

        return Object.keys(selectedRemoteData)
            .filter(
                (key) => key.startsWith("button_") && !key.includes("_times")
            )
            .map((button) => {
                const buttonValue = selectedRemoteData[button];
                return {
                    value: button,
                    label: `${button}: \"${buttonValue}\"`,
                };
            });
    };

    return (
        <div className="extra-buttons-Sequence-container">
            <div className="lircd-health-box">
                <div className="unique-switch-container">
                    <button
                        className="extra-buttons-execute"
                        onClick={executeSequence}
                        disabled={savedSequence.length === 0}
                    >
                        Execute Sequence
                    </button>

                    <label className="unique-switch">
                        <input
                            type="checkbox"
                            checked={ShowSequence}
                            onChange={() => setShowSequence(!ShowSequence)}
                        />
                        <span className="unique-slider"></span>
                    </label>

                    <p>{ShowSequence ? "Hide" : "Show"} sequnce</p>
                </div>
                <h4>Saved Sequances: {AllSavedSequences?.length}</h4>
                <div className="AllSavedSequencesButtons">
                    {AllSavedSequences.map((item) => (
                        <button
                            key={item.key}
                            onClick={() => selectSequence(item.key)}
                        >
                            {item.key.replace("buttonSequenceData_", "")}
                        </button>
                    ))}
                </div>
                <h3>Selected Sequence: {saveSequenceName}</h3>
                {ShowSequence && (
                    <div className="mainSecuenceContainer">
                        <h5 className="extra-buttons-title">
                            Selected Remote: {selectedRemote}
                        </h5>

                        {buttonGroups.map((group, index) => (
                            <div key={index} className="extra-buttons-group">
                                <label className="extra-buttons-label">
                                    Select Button [{index + 1}]:
                                </label>
                                <div className="extra-buttons-control">
                                    <select
                                        className="extra-buttons-select"
                                        value={group.selectedButton || ""}
                                        onChange={(e) =>
                                            handleButtonSelectChange(
                                                index,
                                                e.target.value
                                            )
                                        }
                                        disabled={!selectedRemote}
                                    >
                                        <option value="">
                                            Choose a button
                                        </option>
                                        {populateButtons().map((button) => (
                                            <option
                                                key={button.value}
                                                value={button.value}
                                            >
                                                {button.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <label className="extra-buttons-label">
                                    Add Delay (ms):
                                </label>
                                <div className="extra-buttons-control">
                                    <input
                                        className="extra-buttons-input"
                                        type="number"
                                        value={group.delay}
                                        onChange={(e) =>
                                            handleDelayButtonClick(
                                                index,
                                                e.target.value
                                            )
                                        }
                                        defaultValue={10}
                                        min={0}
                                    />
                                </div>
                            </div>
                        ))}

                        <div className="extra-buttons-actions">
                            <button
                                className="extra-buttons-add"
                                onClick={addButtonGroup}
                            >
                                +
                            </button>
                            <button
                                className="extra-buttons-remove"
                                onClick={removeButtonGroup}
                            >
                                -
                            </button>
                        </div>

                        <div className="SaveSequenceToSystem">
                            <label>Seaquence Name (no spaces)</label>
                            <input
                                type="text"
                                value={saveSequenceName}
                                placeholder="Add sequesnce name without spaces"
                                onChange={(e) =>
                                    setSaveSequenceName(e.target.value.trim())
                                }
                            />

                            <button
                                className="addSequence"
                                onClick={AddSequence}
                                disabled={buttonGroups.length === 0}
                            >
                                Save Sequence
                            </button>

                            <button
                                className="extra-buttons-clear"
                                onClick={clearSequence}
                                disabled={savedSequence.length === 0}
                            >
                                Delete Sequence
                            </button>
                        </div>

                        <p className="extra-buttons-message">{message}</p>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ButtonsSequence;

